import { c as _c } from "react/compiler-runtime";
import { useInfiniteQuery } from '@tanstack/react-query';
import { activitiesApi } from '../api';
import type { Activity } from '../api/types';

// Query keys
export const queryKeys = {
  objectFeed: (objectId: string, objectType: string) => ['activities', 'feed', objectType, objectId] as const
} as const;

// Hook to fetch paginated activity feed for an object
export function useActivityFeed(objectId, objectType, t0) {
  const $ = _c(14);
  const limit = t0 === undefined ? 20 : t0;
  let t1;
  if ($[0] !== objectId || $[1] !== objectType) {
    t1 = queryKeys.objectFeed(objectId, objectType);
    $[0] = objectId;
    $[1] = objectType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== limit || $[4] !== objectId || $[5] !== objectType) {
    t2 = async t3 => {
      const {
        pageParam: t4
      } = t3;
      const pageParam = t4 === undefined ? 0 : t4;
      const activities = await activitiesApi.getObjectFeed(objectId, objectType, {
        limit,
        offset: pageParam
      });
      return activities.filter(_temp).sort(_temp2);
    };
    $[3] = limit;
    $[4] = objectId;
    $[5] = objectType;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== limit) {
    t3 = (lastPage, allPages) => {
      if (lastPage.length < limit) {
        return;
      }
      return allPages.length * limit;
    };
    $[7] = limit;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = !!objectId && !!objectType;
  let t5;
  if ($[9] !== t1 || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = {
      queryKey: t1,
      queryFn: t2,
      getNextPageParam: t3,
      initialPageParam: 0,
      enabled: t4,
      staleTime: 10000
    };
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return useInfiniteQuery(t5);
}
function _temp2(a, b) {
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
}
function _temp(activity) {
  return activity.deletedAt === null;
}